import { createRouter, createWebHashHistory } from 'vue-router';
// import { getCookie } from '../until/tools';
const vueRouter = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path:'/zhitu',
            component: () => import(/* webpackChunkName: "zhitu" */ '../page/zhitu.vue'),
            meta: { title: '首页' },
            children:[
                {
                    path: '/',
                    redirect: '/index'
                },
                {
                    path: '/index',
                    component: () => import(/* webpackChunkName: "index" */ '../page/index.vue'),
                    meta: { title: '首页' },
                    beforeEnter: (to,from) => {
                        if (from.path == '/login/bind_phone') {
                                window.location.reload()
                        }
                    },
                },
                {
                    path: '/attestation',
                    component: () => import(/* webpackChunkName: "attestation" */ '../page/account/attestation.vue'),
                    meta: { title: '机构认证' }
                },
                {
                    path: '/attestationandidentity',
                    component: () => import(/* webpackChunkName: "attestationandidentity" */ '../page/account/attestationAndIdentity.vue'),
                    meta: { title: '机构认证与身份' }
                },
                {
                    path: '/essay',
                    component: () => import(/* webpackChumName: "essayFrame" */ '../page/essay/frame.vue'),
                    children: [
                        {
                            path: '/essay_index',
                            component: () => import(/* webpackChunkName: "essay" */ '../page/essay/index.vue'),
                            meta: { title: '论文发现' },
                            children: [
                                {
                                    path: '/essay_basic',
                                    component: () => import(/* webpackChunkName: "essayBasic" */ '../page/essay/basic.vue'),
                                    children: [
                                        {
                                            path: '/essay_rec',
                                            component: () => import(/* webpackChunkName: "essayRec" */ '../page/essay/rec.vue'),
                                            meta: { title: '论文推荐' },
                                        },
                                        {
                                            path: '/expert_rec',
                                            component: () => import(/* webpackChunkName: "essayExpertRec" */ '../page/essay/expertRec.vue'),
                                            meta: { title: '专家推荐' },
                                        },
                                        {
                                            path: '/essay_collection',
                                            component: () => import(/* webpackChunkName: "essayCollection" */ '../page/essay/collection.vue'),
                                            meta: { title: '论文集' },
                                        },
                                        {
                                            path: '/essay_basic',
                                            redirect: '/essay_collection'
                                        }
                                    ]
                                },
                                {
                                    path: '/essay_filter',
                                    component: () => import(/* webpackChunkName: "essayFilter" */ '../page/essay/filter.vue'),
                                },
                                {
                                    path: '/essay_index',
                                    redirect: '/essay_basic'
                                }
                            ]
                        },
                        {
                            path: '/essay_detail',
                            component: () => import(/* webpackChunkName: "essayDetail" */ '../page/essay/detail.vue'),
                        },
                        {
                            path: '/collection_detail',
                            component: () => import(/* webpackChunkName: "collectionDetail" */ '../page/essay/collectionDetail.vue'),
                        },
                        {
                            path: '/essay_create_collection',
                            component: () => import(/* webpackChunkName: "create_collection" */ '../page/essay/createCollection.vue'),
                        },
                        {
                            path: '/essay',
                            redirect: '/essay_index'
                        }
                    ]
                },
                {
                    path: '/view',
                    component: () => import(/* webpackChunkName: "view" */ '../page/view/frame.vue'),
                    meta: { title: '图情视界' },
                    children: [
                        {
                            path: '/view/index',
                            component: () => import(/* webpackChunkName: "view" */ '../page/view/index.vue'),
                        },
                        {
                            path: '/view/detail',
                            component: () => import(/* webpackChunkName: "viewDetail" */ '../page/view/detail.vue'),
                        },
                        {
                            path: '/view/topic',
                            component: () => import(/* webpackChunkName: "viewDetail" */ '../page/view/topic.vue'),
                        },
                        {
                            path: '/view',
                            redirect: '/view/index'
                        }
                    ]
                },
                {
                    path: '/search',
                    component: () => import(/* webpackChunkName: "search" */ '../page/search/index.vue'),
                    meta: { title: '搜索' },
                },
                {
                    path: '/totalCount',
                    component: () => import(/* webpackChunkName: "searchResult" */ '../page/search/result.vue'),
                    meta: { title: '搜索' },
                },
                {
                    path: '/help',
                    component: () => import(/* webpackChunkName: "helpCenter" */ '../page/help.vue'),
                    meta: { title: '帮助中心' },
                },
                {
                    path: '/personal',//需要登录
                    component: () => import(/* webpackChunkName: "personal" */ '../page/personal.vue'),
                    children: [
                        {
                            path: '/pub',
                            component: () => import(/* webpackChunkName: "pub" */ '../page/pubArticle.vue'),
                        },
                        {
                            path: '/setting',//账户设置
                            component: () => import(/* webpackChunkName: "setting" */ '../page/setting/index.vue'),
                            children: [
                                {
                                    path: '/setting/bind',
                                    component: () => import(/* webpackChunkName: "setting_bind" */ '../page/setting/bind.vue')
                                },
                                {
                                    path: '/setting/message',
                                    component: () => import(/* webpackChunkName: "setting_message" */ '../page/setting/message.vue')
                                },
                                {
                                    path: '/setting/private',
                                    component: () => import(/* webpackChunkName: "setting_private" */ '../page/setting/private.vue')
                                },
                                {
                                    path: '/setting',
                                    redirect: '/setting/bind'
                                }
                            ]
                        },
                        {
                            path: '/message',//通知消息
                            component: () => import(/* webpackChunkName: "message" */ '../page/message/index.vue'),
                        },
                        {
                            path: '/editInfo',//编辑个人资料
                            component: () => import(/* webpackChunkName: "edit_info" */ '../page/editInfo.vue'),
                        },
                        {
                            path: '/vote',
                            component: () => import(/* webpackChunkName: "vote" */ '../page/vote/index.vue'),
                        },
                        {
                            path: '/voteResult',
                            component: () => import(/* webpackChunkName: "voteResult" */ '../page/vote/result.vue'),
                        },
                        {
                            path: '/voteDetail',
                            component: () => import(/* webpackChunkName: "voteDetail" */ '../page/vote/detail.vue'),
                        }
                    ],
                },
                {
                    path: '/user',//个人主页
                    component: () => import(/* webpackChunkName: "user" */ '../page/user/index.vue'),
                    children: [
                        {
                            path: '/user/articles',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/user/articles.vue'),
                        },
                        {
                            path: '/user/thesis',
                            component: () => import(/* webpackChunkName: "user_thesis" */ '../page/user/thesis.vue'),
                        },
                        {
                            path: '/user/praise',
                            component: () => import(/* webpackChunkName: "user_praise" */ '../page/user/praise.vue'),
                        },
                        {
                            path: '/user/collection',
                            component: () => import(/* webpackChunkName: "user_collection" */ '../page/user/collection.vue'),
                        },
                        {
                            path: '/user/focus',
                            component: () => import(/* webpackChunkName: "user_focus" */ '../page/user/focus.vue'),
                        },
                        {
                            path: '/user',
                            redirect: '/user/articles'
                        }
                    ],
                },
                {
                    path: '/activity',
                    component: () => import(/* webpackChunkName: "activity" */ '../page/activity.vue'),
                    meta: { title: '活动通知' },
                },
            ]
        },
        
        {
            path:'/guide',
            component: () => import(/* webpackChunkName: "guide" */ '../page/guide.vue'),
            children:[                        
                {
                    path: '/guide/index',
                    component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/index.vue'),
                },
                {
                    path:'/guide/steps',
                    component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/steps.vue'),
                    children:[
                        {
                            path: '/guide/keyword',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/keyword.vue'),
                        },
                        {
                            path: '/guide/direction',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/direction.vue'),
                        },                        
                        {
                            path: '/guide/journal',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/journal.vue'),
                        },
                        {
                            path: '/guide/subject',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/subject.vue'),
                        },
                        {
                            path: '/guide/documents',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/documents.vue'),
                        },
                        {
                            path: '/guide/report',
                            component: () => import(/* webpackChunkName: "user_articles" */ '../page/guide/report.vue'),
                        }
                    ]
                },
                {
                    path: '/guide',
                    redirect: '/guide/index'
                }
            ]
        },  
        {
            path: '/agreement',
            component: () => import(/* webpackChunkName: "agreement" */ '../page/account/agreement.vue'),
            meta: { title: '知图协议' }
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../page/account/index.vue'),
            meta: { title: '登录' },
            children: [
                {
                    path: '/login/login_basic',
                    component: () => import(/* webpackChunkName: "login_basic" */ '../page/account/Login.vue'),
                    meta: { title: '登录' }
                },
                {
                    path: '/login/bind',
                    component: () => import(/* webpackChunkName: "bind" */ '../page/account/bind.vue'),
                    meta: { title: '绑定搜知账号' },
                    // beforeEnter: (to, from, next) => {
                    //     if (from.path == '/login/login_basic') {
                    //         next();
                    //     } else {
                    //         next('/login/login_basic')
                    //     }
                    // },
                },
                {
                    path: '/login/guidance',
                    component: () => import(/* webpackChunkName: "guidance" */ '../page/account/guidance.vue'),
                    meta: { title: '前往机构认证' }
                },
                {
                    path: '/login/bind_phone',
                    component: () => import(/* webpackChunkName: "bind_phone" */ '../page/account/bindphone.vue'),
                    meta: { title: '绑定手机号' }
                },
                {
                    path: '/login',
                    redirect: '/login/login_basic'
                }
            ],
        },
        
        {
            path: '/',
            redirect: '/index'
        },
    ]
});
export default vueRouter;